import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';

//* import css
import cssClasses from "./CreateUser.module.css";

//* import sub-component
import DropDown from '../../../Subcomponents/DropDown';
import Button from '../../../Subcomponents/Button';
import { getAllRoles, getRoleById, getRoleByParentRole, getUserByRoleId } from '../../../Services/Roles';
import { getUserByRoleName, updateUser } from '../../../Services/Users';
import { errorTost, successTost } from '../../../Services/Toast';

const AssignRole = forwardRef(({ userObject, setUserObject, onTabChange }, ref) => {

  const [userChildData, setUserChildData] = useState({
    roleId: "",
    parentId: "",
  })
  const [fieldHelperText, setFieldHelperText] = useState({
    roleId: "",
    parentId: "",
  })

  const [roleServerList, setRoleServerList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  
  const [parentUserList, setParentUserList] = useState([]);

  useEffect(() => {
    // console.log(JSON.parse(JSON.stringify({ ...userObject })));
    setUserChildData({roleId: userObject?.roleId ,parentId: userObject?.parentId});
    getRolesListFromServer(userObject?.roleId);
  }, [userObject])
  
  // useEffect(() => {
  //   getRolesListFromServer();
  // }, [])

  async function getRolesListFromServer(_roleId) {
    const response = await getAllRoles();
    if (response.data) {
      const _roles = response.data;
      console.log(_roles);
      setRoleServerList(_roles);
      setRoleList(_roles.map(m => ({label: m.title, value: m.roleId})));
      if (_roleId) {
        getParentUsers(_roles, _roleId);
      }
    }
  }

  async function getParentUsers(_roleServerList, _roleId) {
    // getUserByRoleName
    let _roleObject = _roleServerList.find(f => f.roleId === _roleId);
    console.log(_roleObject);

    if (_roleObject?.parentRoleId) {
      const getUserByRoleNameResponse = await getUserByRoleName(_roleObject?.parentRoleId);
      console.log("getUserByRoleNameResponse -> ", getUserByRoleNameResponse);
      if (getUserByRoleNameResponse.data) {
        setParentUserList(getUserByRoleNameResponse?.data?.map(m => ({label: m.name, value: m.userId})))
      }
    }
  }

  async function clickOnAssignRole() {
    let isValidArray = [
      {
        fieldName: "roleId",
        isValid: isRequiredFieldValid(fieldHelperText.roleId, "role", null, null),
      },
      {
        fieldName: "parentId",
        isValid: isRequiredFieldValid(fieldHelperText.parentId, "Parent", null, null),
      },
    ]

    if (isValidArray.some(s => !s.isValid.flag)) {
      let obj = {};
      isValidArray.forEach(ele => {
        if (!ele.isValid.flag) {
          obj[ele.fieldName] = ele.isValid.helperText;
        }
      })
      setFieldHelperText({ ...fieldHelperText, ...obj });

      if (userObject?.userId && userObject?.userId !== "") {
        //todo update
        console.log('update use rdata');
       
        const response = await updateUser({
          roleId: userChildData.roleId,
          parentId: userChildData.parentId,
          completedTabs: (!userObject.completedTabs.includes('Assign Role')) ? [...userObject.completedTabs, 'Assign Role'] : userObject.completedTabs
        }, userObject.userId);


        console.log('update role', response);


        if (response?.data) {
          setUserObject(response.data)
          successTost('User assigned role successfully');
          onTabChange("Assigned Projects");
        } else {
          errorTost('Something went wrong');
        }

      } else {
        //todo insert
      }
      return;
    }
  }

  function goToBack() {
    onTabChange("Add Details");
  }

  return (
    <>
      <div className={cssClasses.assignRoleWrapper}>
        <div>
          <div className={cssClasses.inputWrapper}>
            <label>Select Roles <span>*</span></label>
            <DropDown
              placeholder='Select Role'
              list={roleList}
              onChangeSelect={(_value) => {
                setUserChildData((pre) => {
                  pre.roleId = _value;
                  pre.parentId = "";
                  return { ...pre };
                })
                getParentUsers(roleServerList, _value);
              }}
              selectedValue={userChildData.roleId}
              style={{ selectedColor: "#98A2B3", background: "#F2F4F7" }}
              helperText={(userChildData.roleId) ? '' : fieldHelperText.roleId}
            />
          </div>

          <div className={cssClasses.inputWrapper}>
            <label>Assign Parent <span>*</span></label>
            <DropDown
              placeholder='Select Parent'
              list={parentUserList}
              // onChangeSelect={(e) => { setFilterBy(e) }} 
              onChangeSelect={(e) => {
                setUserChildData((pre) => {
                  pre.parentId = e;
                  return { ...pre };
                })
              }}
              selectedValue={userChildData.parentId}
              style={{ selectedColor: "#98A2B3", background: "#F2F4F7" }}
              helperText={(userChildData.parentId) ? '' : fieldHelperText.parentId}
              disable={!userChildData?.roleId}
            />
          </div>
        </div>
        <div>

        </div>
      </div>

      <div className={cssClasses.buttonWrapper}>
        <div>
          <Button
            style={{
              color: "#fff",
              backgroundColor: "#D0D5DD",
              fontSize: "1.4rem",
              lineHeight: "2rem",
              fontFamily: "Roboto-Regular",
            }}
            btnName={"Back"}
            clicked={goToBack}
            // btnIcon={<AddIcon style={{width: "15px", height: "15px"}}/>}
            iconPosition={"left"}
            disable={!(userChildData?.roleId && userChildData?.parentId)}
          />
        </div>

        <div>
          <Button
            style={{
              color: "#fff",
              backgroundColor: "#1570EF",
              fontSize: "1.4rem",
              lineHeight: "2rem",
              fontFamily: "Roboto-Regular",
            }}
            btnName={"Assign Role & Next"}
            clicked={clickOnAssignRole}
            // btnIcon={<AddIcon style={{width: "15px", height: "15px"}}/>}
            iconPosition={"left"}
            disable={!(userChildData?.roleId && userChildData?.parentId)}
          />
        </div>
      </div>
    </>
  )
})

export default AssignRole;

function isRequiredFieldValid(inputText, fieldName, min, max) {
  inputText = inputText.toString();
  let flag = true;
  let helperText = "";
  if (!inputText || inputText === "") {
    flag = false;
    helperText = `Please Select ${fieldName}.`;
  } else if (min && inputText.length < min) {
    flag = false;
    helperText = `Please Select at least ${min} words.`;
  } else if (max && inputText.length > max) {
    flag = false;
    helperText = `Please Select less than ${max} words.`;
  }
  return { flag, helperText };
}